export function trackEvent(action, params = {}) {
  if (typeof window.gtag !== "function") {
    console.warn("Google Analytics not initialized yet");
    return;
  }
  window.gtag("event", action, params);
}
